module.exports = __webpack_public_path__ + "media/images/emoticons/pass-9659d41b871ccde2cac409bc0b67ffdf.gif";